import React, { useEffect, useState } from "react";
import { DateInput } from "../../../utils/Custom/custominput";
import { SearchToggleButton } from "../../../utils/Custom/Button";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import ListView from "../../../utils/Custom/listView";
import ExcelDownload from "../../../utils/commonComponent/ExcelDownload";
import moment from "moment";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { getFormattedDates } from "../../../utils/utils";
import { getPermissions } from "../rbac/hasAccess";

const headers = ["id", "Client", "jobNumber", "poNumber", "Total_Service"];
const notNeededColumn = [
  "status",
  "clientId",
  "servicesNameId",
  "id",
  "inspectorId",
  "jobRegisterId",
  "address",
];

const ProgressReport = (props) => {
  const permissions = getPermissions(props.moduleId);
  const [from, setFromDate] = useState(null);
  const [to, setToDate] = useState(null);
  const [searched, setSearched] = React.useState(false);
  const [jobNumberList, setjobNumberList] = React.useState([]);
  const [selectedJobIds, setSelectedJobIds] = React.useState([]);
  const [progressList, setProgressList] = useState([]);
  const [inspectionServiceTable, setInspectionServiceTable] = useState([]);

  const getQuery = () => {
    let whereConditions = [];

    // if (selectedInspectorId) {
    //   whereConditions.push(`jRI.inspectorId = ${selectedInspectorId}`);
    // }

    if (to != null && from != null) {
      const { fromDate, toDate } = getFormattedDates(from, to);
      whereConditions.push(`DATE(jR.inspectionPerformedDate) BETWEEN '${fromDate}' AND '${toDate}'`);
    }

    if (selectedJobIds?.length > 0) {
      const jobIds = selectedJobIds.map((id) => `'${id}'`).join(",");
      whereConditions.push(`jR.id IN (${jobIds})`);
    }

    const whereClause = whereConditions.length ? `WHERE ${whereConditions.join(" AND ")}` : "";

    const query = `SELECT cl.companyName AS Client, jR.*, COUNT(jRI.id) AS Total_Service FROM jobRegister jR LEFT JOIN clients cl ON jR.clientId = cl.id LEFT JOIN addresses a ON jR.address = a.id LEFT JOIN jobRegisterInspection jRI ON jR.id = jRI.jobRegisterId ${whereClause} GROUP BY jR.id ORDER BY jR.id DESC;`;

    return query;
  };

  const fetchinspectionTaskSummary = async () => {
    try {
      const query = getQuery();
      const inspectionData = await fetchQuery(query);
      const modifiedData = inspectionData.map((item) => ({
        ...item,
        inspectionPerformedDate: item.inspectionPerformedDate
          ? moment(item.inspectionPerformedDate).format("DD-MM-YYYY")
          : "",
      }));
      setProgressList(modifiedData);

      // NEW: Fetch related jobRegisterInspection data
      const secondQuery = `SELECT cl.companyName AS client, jr.jobNumber, jr.poNumber, ii.subcategory FROM jobRegisterInspection jri LEFT JOIN jobRegister jr ON jri.jobRegisterId = jr.id LEFT JOIN clients cl ON jr.clientId = cl.id LEFT JOIN inspectionItems ii ON jri.servicesNameId = ii.id WHERE jr.id IN (${selectedJobIds
        ?.map((id) => `'${id}'`)
        .join(",")})`;

      const secondTableData = await fetchQuery(secondQuery);
      setInspectionServiceTable(secondTableData);
    } catch (error) {
      console.error("Error fetching inspectionData data:", error);
    }
  };

  const handleSearch = () => {
    if (!selectedJobIds) {
      alert("Please select a job.");
      return;
    }
    fetchinspectionTaskSummary();
    setSearched(true);
  };

  const clearSearch = () => {
    setSearched(false);
    setProgressList([]);
    setSelectedJobIds([]);
    setFromDate(null);
    setToDate(null);
  };

  const fetchAllJobs = async () => {
    try {
      const jobList = await fetchQuery(
        "SELECT * FROM jobRegister order by id desc"
      );
      const jobNumberListFormatted = jobList.map((job) => ({
        id: job.id,
        label: job.jobNumber,
      }));
      setjobNumberList(jobNumberListFormatted);
    } catch (error) {
      console.error("Error fetching all jobRegister:", error);
    }
  };

  useEffect(() => {
    fetchAllJobs();
  }, []);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-2 my-3">
        <div className="w-full">
          <DateInput
            id="from-date"
            label="From Date"
            value={from}
            onChange={(val) => {
              setFromDate(val);
              setSearched(false);
            }}
          />
        </div>
        <div className="w-full">
          <DateInput
            id="to-date"
            label="To Date"
            value={to}
            onChange={(val) => {
              setToDate(val);
              setSearched(false);
            }}
          />
        </div>
        <div>
          <Autocomplete
            size="small"
            id="combo-box-demo"
            options={[
              { id: "selectAll", label: "Select All" },
              ...jobNumberList,
            ]}
            disableCloseOnSelect
            multiple
            limitTags={3}
            value={jobNumberList?.filter((option) =>
              selectedJobIds.includes(option.id)
            )}
            onChange={(event, value) => {
              const selectedIds = value.map((e) => e.id);

              if (selectedIds.includes("selectAll")) {
                // If "Select All" is selected, select all options
                if (selectedJobIds.length === jobNumberList?.length) {
                  // If all are selected, remove "Select All"
                  setSelectedJobIds([]);
                } else {
                  // Select all options
                  setSelectedJobIds(jobNumberList.map((e) => e.id));
                }
              } else {
                setSelectedJobIds(selectedIds);
              }
              setSearched(false);
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  style={{ marginRight: 8 }}
                  checked={
                    option.id === "selectAll"
                      ? selectedJobIds.length === jobNumberList.length
                      : selectedJobIds.includes(option.id)
                  }
                />
                {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label="Select Job" />
            )}
          />
        </div>
        <div>
          <SearchToggleButton
            searched={searched}
            onSearch={handleSearch}
            onClear={clearSearch}
          />
        </div>

        {progressList?.length > 0 && (permissions.excelDownload || permissions.allAccess) && (
          <div>
            <ExcelDownload
              finalData={progressList}
              notNeededColumn={notNeededColumn}
              secondTable={inspectionServiceTable}
            />
          </div>
        )}
      </div>

      <ListView headers={headers} data={progressList} />
    </>
  );
};

export default ProgressReport;
